import { Navigate, Outlet } from "react-router-dom"

export const PublicRoutes = (isAuth) => {
    return isAuth? <Navigate to="/dashboard" replace /> : <Outlet />
}